<template>
  <div class="dashboard-pages">
    <v-card>
      <v-card-text>
        <form @submit.prevent="save($event)">
          <v-layout row wrap>
            <!-- <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="cashierLoginOptions"
                v-model="systemSettings.cashier_login_option"
                :label="$t('Cashier Login Option')"
                box
                :readonly="userData.user_id > 1"
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
              ></v-autocomplete>
            </v-flex>-->

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                v-if="userData.user_id === 1"
                :items="systemCurrencyOptions"
                v-model="systemSettings.system_currency"
                :label="`${$t('System Currency')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="system_currency"
                :error="errors.has('system_currency')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                v-if="userData.user_id === 1"
                :items="accountingOptions"
                v-model="systemSettings.outlet_accounting_separation"
                :label="`${$t('Outlet Accounting Separation')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="outlet_accounting_separation"
                :error="errors.has('outlet_accounting_separation')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                v-if="userData.user_id === 1"
                :items="activeInactiveOptions"
                v-model="systemSettings.open_purchase_payment"
                :label="`${$t('Open Purchase Payment Status')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="open_purchase_payment"
                :error="errors.has('open_purchase_payment')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.production_collections"
                :label="`${$t('Product Collections')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="production_collections"
                :error="errors.has('production_collections')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.product_brand_or_made_in"
                :label="`${$t('Product Brand / Made In')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="product_brand_or_made_in"
                :error="errors.has('product_brand_or_made_in')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.sale_detail"
                :label="`${$t('Sale Detail')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="sale_detail"
                :error="errors.has('sale_detail')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.product_expiry"
                :label="`${$t('Product Expiry Status')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="product_expiry"
                :error="errors.has('product_expiry')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.purchase_tax"
                :label="`${$t('Purchase Tax Status')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="purchase_tax"
                :error="errors.has('purchase_tax')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.opening_balance_status"
                :label="`${$t('Opening Balance Status')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="opening_balance_status"
                :error="errors.has('opening_balance_status')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4>
              <v-autocomplete
                :items="activeInactiveOptions"
                v-model="systemSettings.revenue_tax"
                :label="`${$t('Revenue Tax Status')} *`"
                box
                hide-details
                background-color="gray"
                :menu-props="{ transition: 'slide-y-transition' }"
                data-vv-name="revenue_tax"
                :error="errors.has('revenue_tax')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex pa-2 xs6 md4 offset-xs3 offset-md4 v-if="systemSettings.revenue_tax === 'Active'">
              <v-text-field
                v-model="systemSettings.tax_amount"
                :label="$t('Tax Percentage')"
                box
                suffix="%"
                hide-details
                background-color="gray"
                data-vv-name="tax_amount"
                :error="errors.has('tax_amount')"
                v-validate="'required|decimal:3|max_value:100'"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex mt-5 xs4 offset-xs4>
              <v-layout justify-end>
                <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                  <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                  {{ $t('Update') }}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false
    }
  },

  mounted() {
    this.fetchSystemSettings()
    this.setAppBarTitle({
      title: this.$t('System Configurations'),
      icon: 'fa-cogs'
    })
  },

  computed: {
    ...mapGetters({
      cashierLoginOptions: 'configurations/getCashierLoginOptions',
      systemCurrencyOptions: 'configurations/getSystemCurrencyOptions',
      accountingOptions: 'configurations/getAccountingOptions',
      activeInactiveOptions: 'configurations/getActiveInactiveOptions',
      systemSettings: 'configurations/getSystemSettings',
      userData: 'auth/getAuthUserData'
    })
  },

  methods: {
    ...mapActions({
      fetchSystemSettings: 'configurations/fetchSystemSettings',
      updateSystemSettingInfo: 'configurations/updateSystemSettingInfo'
    }),

    save(event) {
      this.btnUpdateLoading = true
      let formData = new FormData(event.target)
      formData.append('cashier_login_option', this.systemSettings.cashier_login_option)
      formData.append('system_currency', this.systemSettings.system_currency)
      formData.append('opening_balance_status', this.systemSettings.opening_balance_status)
      formData.append('purchase_tax', this.systemSettings.purchase_tax)
      formData.append('product_expiry', this.systemSettings.product_expiry)
      formData.append('open_purchase_payment', this.systemSettings.open_purchase_payment)
      formData.append('outlet_accounting_separation', this.systemSettings.outlet_accounting_separation)
      formData.append('production_collections', this.systemSettings.production_collections)
      formData.append('product_brand_or_made_in', this.systemSettings.product_brand_or_made_in)
      formData.append('sale_detail', this.systemSettings.sale_detail)
      formData.append('quotation_detail', this.systemSettings.quotation_detail)
      formData.append('revenue_tax', this.systemSettings.revenue_tax)
      formData.append('tax_amount', this.systemSettings.tax_amount)

      this.updateSystemSettingInfo(formData)
        .then(() => {
          this.btnUpdateLoading = false
          this.fetchSystemSettings()
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
